export enum OpenaiYamlPreviewMode {
  Form = "form",
  Raw = "raw",
}
